import { Icon } from '../icon/icon'
import Text from '~/components/text/text'
import { cn } from '~/utils/misc'

interface WarningBlockProps {
	text: string
	size?: 'sm' | 'md'
}

export default function WarningBlock({ text, size = 'md' }: WarningBlockProps) {
	return (
		<div
			className={cn(
				'rounded-xl border border-warning/60 bg-warning/15 dark:border-warning/40 dark:bg-warning/5',
				size === 'md' && 'w-full p-4',
				size === 'sm' && 'inline-block px-2 py-1',
			)}
		>
			<div className="flex flex-col gap-2 md:flex-row">
				<Icon
					name="warning-triangle"
					size={size === 'md' ? 'xl' : 'md'}
					className="mr-2 shrink-0 text-warning-foreground"
				/>
				<Text as={size === 'md' ? undefined : 'sm'}>{text}</Text>
			</div>
		</div>
	)
}
